import { apiClient } from "@/lib/api/client";
import type {
  ApiMessageResponse,
  AppointmentCreatePayload,
  AppointmentCreateResponse,
  AppointmentDoctorsResponse,
  AppointmentSlotsResponse,
  AppointmentSummaryDto,
  PaginatedBusinessesResponse,
  VirtualAppointmentDto,
} from "@/features/appointments/types";

export interface AppointmentSlotsParams {
  staff_user_id: number;
  business_id: number;
  for_date: string;
  slot_minutes?: number;
  step_minutes?: number;
}

/**
 * Merr business-et publike qe mund te shfaqen ne booking flow.
 */
export const getBookableBusinesses = async (): Promise<PaginatedBusinessesResponse> => {
  const response = await apiClient.get<PaginatedBusinessesResponse>("/businesses/directory");
  return response.data;
};

/**
 * Merr katalogun publik te mjekeve per nje business.
 */
export const getBookableDoctors = async (businessId: number, serviceId?: number | null): Promise<AppointmentDoctorsResponse> => {
  const response = await apiClient.get<AppointmentDoctorsResponse>("/appointments/doctors", {
    params: { business_id: businessId, service_id: serviceId ?? undefined },
  });
  return response.data;
};

/**
 * Merr slot-et e lira per nje mjek ne nje date te caktuar.
 */
export const getAvailableSlots = async (params: AppointmentSlotsParams): Promise<AppointmentSlotsResponse> => {
  const response = await apiClient.get<AppointmentSlotsResponse>("/appointments/slots", {
    params,
  });
  return response.data;
};

/**
 * Krijon nje termin ne statusin requested.
 */
export const bookAppointment = async (payload: AppointmentCreatePayload): Promise<AppointmentCreateResponse> => {
  // POST /appointments/ — trailing slash i detyrueshëm: FastAPI nuk ridrejton POST-et
  const response = await apiClient.post<AppointmentCreateResponse>("/appointments/", payload);
  return response.data;
};

/**
 * Kryen pagesen dhe e kalon terminin ne confirmed.
 */
export const payAppointment = async (appointmentId: number): Promise<ApiMessageResponse> => {
  const response = await apiClient.patch<ApiMessageResponse>(`/appointments/${appointmentId}/pay`);
  return response.data;
};

/**
 * Merr listen personale te termineve sipas rolit aktiv.
 */
export const getMyAppointments = async (): Promise<AppointmentSummaryDto[]> => {
  const response = await apiClient.get<AppointmentSummaryDto[]>("/appointments/mine");
  return response.data;
};

/** Mjeku nis thirrjen video → gjeneron / kthen linkun Jitsi. */
export const startVideoCall = async (appointmentId: number): Promise<{ meeting_link: string }> => {
  const response = await apiClient.post<{ meeting_link: string }>(`/appointments/${appointmentId}/start-call`);
  return response.data;
};

/** Terminet virtuale ±30 min nga tani (për badge LIVE). */
export const getActiveVirtualAppointments = async (): Promise<VirtualAppointmentDto[]> => {
  const response = await apiClient.get<VirtualAppointmentDto[]>("/appointments/active-virtual");
  return response.data;
};
